export default {
  methods: {
    decodeToken (token) {
      let base64Url = token.split('.')[1]
      let base64 = base64Url.replace('-', '+').replace('_', '/')
      return JSON.parse(window.atob(base64))
    },

    setTokenAndRedirect (accessToken) {
      let url
      let lang = this.$route.params.lang
      let payload = this.decodeToken(accessToken)
      let expirationTime = new Date(payload.exp * 1000)

      window.$cookies.set('access_token', accessToken, expirationTime, '/')

      if (payload.aud === 'admin') {
        url = `${process.env.BACKOFFICE_AREA_URL}` /// ${this.lang}/
      }

      if (payload.aud === 'user') {
        url = `/${lang}${process.env.PERSONAL_AREA_URL}`
      }

      if (payload.aud === 'partner') {
        url = `/${lang}${process.env.PARTNERS_PLATFORM_URL}`
      }

      window.location.replace(url)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/platformRedirect.js